import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BaseInitialState, StateStatus } from '../extension-store/interfaces/extension-store.interfaces';

export interface License {
  isLicensed?: boolean;
}

export interface InitialLicenseState extends BaseInitialState {
  licenseState: License;
}

const initialState: InitialLicenseState = {
  status: StateStatus.IDLE,
  error: null,
  licenseState: {
    isLicensed: false,
  },
};

export const LicenseState = createSlice({
  name: 'LicenseStateReducer',
  initialState,
  reducers: {
    setLicensed: (mutableState) => {
      mutableState.licenseState.isLicensed = true;
    },
    setUnlicensed: (mutableState) => {
      mutableState.licenseState.isLicensed = false;
    },
    setLicenseStatus: (mutableState, action: PayloadAction<boolean>) => {
      mutableState.licenseState.isLicensed = action.payload;
    },
  },
});

export const { setLicensed, setUnlicensed, setLicenseStatus } = LicenseState.actions;
export const isLicensed = (state: InitialLicenseState) => state.licenseState.isLicensed;
